import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './ImageCompareBox.css'
import SvgImage from '@healthwise-ui/core/SvgImage'
import theme from '../common/theme'

class ImageCompareBox extends Component {
  render() {
    const parts = []
    let part = {}
    let counter = 0
    for (const child of this.props.children) {
      if (child && typeof child === 'object' && child.type !== 'h3') {
        for (const section of child.props.children) {
          if (section && typeof section === 'object') {
            if (section.props.className === 'HwImageWrapper') {
              for (const element of section.props.children) {
                if (
                  element.props &&
                  element.props.src &&
                  new RegExp('\\.svg$').test(element.props.src)
                ) {
                  part.image = (
                    <SvgImage
                      src={element.props.src}
                      alt={element.props.alt}
                      additionalClassName={element.props.className}
                      theme={theme.defaultTheme}
                    />
                  )
                } else {
                  part.image = section
                }
              }
            } else {
              part.content = section
            }

            if (typeof part.content === 'object') {
              parts.push(
                <div
                  key={`hw-image-compare-box-item-key-${counter++}`}
                  className={`hw-image-compare-box-item ${
                    styles.image_compare_box_item
                  }`}
                >
                  <div
                    className={`hw-image-compare-box-image ${
                      styles.image_compare_box_image
                    }`}
                  >
                    {part.image}
                  </div>
                  <div
                    className={`hw-image-compare-box-content ${
                      styles.image_compare_box_content
                    }`}
                  >
                    {part.content}
                  </div>
                </div>
              )
              part = {}
            }
          }
        }
      }
    }

    return (
      <fieldset
        className={`hw-image-compare-box-wrapper ${
          styles.image_compare_box_wrapper
        }`}
      >
        <div className={`hw-image-compare-box ${styles.image_compare_box}`}>
          {parts}
        </div>
      </fieldset>
    )
  }
}

ImageCompareBox.propTypes = {
  children: PropTypes.node
}

export default ImageCompareBox



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/ImageCompareBox/index.js